(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["article-carousel"] && !Shopify.designMode) return;
  try {
    class ArticleCarouselBlock extends HTMLElement {
    constructor() {
      super();

      this.onPreviousClick = this.onPreviousClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onCarouselScroll = this.onCarouselScroll.bind(this);
      this.onWindowResize = this.onWindowResize.bind(this);
      this.onWheel = this.onWheel.bind(this);
    }

    connectedCallback() {
      this.carousel = this.querySelector('[data-article-carousel]');
      this.carouselInner = this.querySelector('[data-article-carousel-track]');
      this.previousButton = this.querySelector('[data-article-carousel-prev]');
      this.nextButton = this.querySelector('[data-article-carousel-next]');

      this.previousButton?.addEventListener('click', this.onPreviousClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.carouselInner?.addEventListener('scroll', this.onCarouselScroll, { passive: true });
      this.carouselInner?.addEventListener('wheel', this.onWheel, { passive: false });
      window.addEventListener('resize', this.onWindowResize);

      this.updateCarouselControls();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.onPreviousClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.carouselInner?.removeEventListener('scroll', this.onCarouselScroll);
      this.carouselInner?.removeEventListener('wheel', this.onWheel);
      window.removeEventListener('resize', this.onWindowResize);
    }

    updateCarouselControlPosition() {
      if (!this.carouselInner || !this.carousel) return;

      const firstTile = this.carouselInner.querySelector('.article-carousel__tile');
      const visualTarget = firstTile?.querySelector('.article-tile__image-wrapper') || firstTile;
      if (!visualTarget) return;

      const carouselRect = this.carousel.getBoundingClientRect();
      const visualRect = visualTarget.getBoundingClientRect();
      const visualCenter = visualRect.top + (visualRect.height / 2) - carouselRect.top;
      this.carousel.style.setProperty('--article-carousel-control-top', `${visualCenter}px`);
    }

    getScrollStep() {
      const firstTile = this.carouselInner?.querySelector('.article-carousel__tile');
      if (!firstTile) return this.carouselInner?.clientWidth || 0;

      const styles = window.getComputedStyle(this.carouselInner);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return firstTile.getBoundingClientRect().width + gap;
    }

    scrollByStep(direction) {
      if (!this.carouselInner) return;

      this.carouselInner.scrollBy({
        left: this.getScrollStep() * direction,
        behavior: 'smooth'
      });
    }

    onPreviousClick() {
      this.scrollByStep(-1);
    }

    onNextClick() {
      this.scrollByStep(1);
    }

    onCarouselScroll() {
      this.updateCarouselControls();
    }

    onWindowResize() {
      window.requestAnimationFrame(() => this.updateCarouselControls());
    }

    updateCarouselControls() {
      if (!this.carouselInner || !this.carousel) return;

      this.updateCarouselControlPosition();

      const maxScrollLeft = this.carouselInner.scrollWidth - this.carouselInner.clientWidth;
      const isScrollable = maxScrollLeft > 1;
      const isAtStart = this.carouselInner.scrollLeft <= 1;
      const isAtEnd = this.carouselInner.scrollLeft >= maxScrollLeft - 1;

      this.carousel.classList.toggle('is-scrollable', isScrollable);

      if (this.previousButton) {
        this.previousButton.disabled = !isScrollable || isAtStart;
        this.previousButton.setAttribute('aria-hidden', (!isScrollable).toString());
      }

      if (this.nextButton) {
        this.nextButton.disabled = !isScrollable || isAtEnd;
        this.nextButton.setAttribute('aria-hidden', (!isScrollable).toString());
      }
    }

    onWheel(event) {
      if (!this.carouselInner) return;
      if (Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;

      const maxScrollLeft = this.carouselInner.scrollWidth - this.carouselInner.clientWidth;
      const direction = Math.sign(event.deltaY);
      const canScrollLeft = this.carouselInner.scrollLeft > 1;
      const canScrollRight = this.carouselInner.scrollLeft < maxScrollLeft - 1;

      if ((direction < 0 && !canScrollLeft) || (direction > 0 && !canScrollRight)) return;

      event.preventDefault();
      this.carouselInner.scrollLeft += event.deltaY;
    }
  }

  if (!customElements.get('article-carousel-block')) {
    customElements.define('article-carousel-block', ArticleCarouselBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-grid-display"] && !Shopify.designMode) return;
  try {
    class CollectionGridDisplay extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('#CollectionGrid');
      this.loadMoreContainer = this.querySelector('#GridLoadMoreContainer');
      this.loadMoreButton = this.querySelector('#GridLoadMoreButton');
      this.emptyState = this.querySelector('#CollectionGridEmptyState');
      this.spinner = this.querySelector('.collection-grid__loading-spinner');
      this.content = this.querySelector('.collection-grid__load-more-content');
      
      this.productsPerPage = 21;
      this.currentPage = 1;
      this.allProducts = [];
      this.filteredProducts = [];
      this.activeFilters = {};
      this.hasMoreOnServer = false;
      this.isLoading = false;

      this.initEventListeners();
      this.initProducts();
    }

    initProducts() {
      // Collect initial products from DOM
      this.allProducts = Array.from(this.grid.querySelectorAll('.product-tile'));
      this.filteredProducts = [...this.allProducts];
      this.renderProducts();
      this.updateLoadMoreVisibility();
    }

    initEventListeners() {
      // Listen for load more button click
      this.loadMoreButton?.addEventListener('click', () => this.onLoadMoreClick());

      // Listen for data provider events
      document.addEventListener('collection:data-ready', (e) => this.onDataReady(e));
      document.addEventListener('collection:new-data', (e) => this.onNewData(e));
      document.addEventListener('collection:filter-changed', (e) => this.onFilterChanged(e));
      document.addEventListener('collection:loading', (e) => this.onLoading(e));
    }

    onDataReady(e) {
      this.hasMoreOnServer = e.detail.hasMore;
      this.activeFilters = e.detail.activeFilters || {};
      this.applyFilters();
      this.renderProducts();
      this.updateLoadMoreVisibility();
    }

    onNewData(e) {
      const { gridProducts, hasMore, advancePage } = e.detail;
      this.hasMoreOnServer = hasMore;

      // Append new products to the grid
      if (gridProducts && gridProducts.length > 0) {
        gridProducts.forEach(productHtml => {
          this.grid.insertAdjacentHTML('beforeend', productHtml);
        });

        // Update product references
        this.allProducts = Array.from(this.grid.querySelectorAll('.product-tile'));
        
        // Re-apply active filters after adding products.
        this.applyFilters();
      }

      if (advancePage !== false) {
        this.currentPage++;
      }

      this.renderProducts();
      this.updateLoadMoreVisibility();
    }

    onFilterChanged(e) {
      const { activeFilters, hasMore } = e.detail;
      this.activeFilters = activeFilters || {};
      this.hasMoreOnServer = hasMore;
      this.currentPage = 1;
      
      this.applyFilters();
      this.renderProducts();
      this.updateLoadMoreVisibility();
    }

    onLoading(e) {
      this.isLoading = e.detail.isLoading;
      this.updateButtonState();
      this.updateEmptyState();
    }

    hasActiveFilters() {
      return Object.keys(this.activeFilters).length > 0;
    }

    getProductFilterValues(product, filterType) {
      const dataAttributeKey = filterType.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
      const dataValue = product.dataset[dataAttributeKey] || '';

      return dataValue
        .toLowerCase()
        .split(',')
        .map((value) => value.trim())
        .filter((value) => value !== '');
    }

    matchesAllFilters(product) {
      const filterUtils = window.CollectionFilterUtils;
      const filterTypes = Object.keys(this.activeFilters);
      if (!filterTypes.length) return true;

      return filterTypes.every((filterType) => {
        const filterCriteria = filterUtils.normalizeCriteria(this.activeFilters[filterType]);
        if (!filterCriteria.length) return true;

        const productValues = this.getProductFilterValues(product, filterType);
        if (!productValues.length) return false;

        return filterCriteria.some((criterion) => filterUtils.matchesFilterCriterion(productValues, filterType, criterion));
      });
    }

    applyFilters() {
      if (!this.hasActiveFilters()) {
        this.filteredProducts = [...this.allProducts];
        this.dispatchResultsCount();
        return;
      }

      this.filteredProducts = this.allProducts.filter((product) => this.matchesAllFilters(product));
      this.dispatchResultsCount();
    }

    dispatchResultsCount() {
      this.dispatchEvent(new CustomEvent('collection:results-count-updated', {
        detail: {
          count: this.filteredProducts.length,
          hasActiveFilters: this.hasActiveFilters()
        },
        bubbles: true
      }));
    }

    onLoadMoreClick() {
      if (this.isLoading) return;

      const totalVisible = this.currentPage * this.productsPerPage;
      const hasMoreLocal = totalVisible < this.filteredProducts.length;

      if (hasMoreLocal) {
        // Show more from local pool
        this.currentPage++;
        this.renderProducts();
        this.updateLoadMoreVisibility();
      } else if (this.hasMoreOnServer) {
        // Request more from server
        document.dispatchEvent(new CustomEvent('collection:request-more', { bubbles: true }));
      }
    }

    renderProducts() {
      // Hide all products first
      this.allProducts.forEach(p => p.style.display = 'none');

      // Show filtered products up to current page
      const totalVisible = this.currentPage * this.productsPerPage;
      this.filteredProducts.slice(0, totalVisible).forEach(product => {
        product.style.display = 'flex';
      });

      this.updateEmptyState();
    }

    updateLoadMoreVisibility() {
      if (!this.loadMoreContainer) return;

      const totalVisible = this.currentPage * this.productsPerPage;
      const hasMoreLocal = totalVisible < this.filteredProducts.length;
      const shouldShow = this.filteredProducts.length > 0 && (hasMoreLocal || this.hasMoreOnServer);

      this.loadMoreContainer.classList.toggle('collection-grid__load-more-container--hidden', !shouldShow);
    }

    updateEmptyState() {
      if (!this.emptyState) return;

      const shouldShowEmptyState = this.filteredProducts.length === 0 && !this.isLoading;
      this.emptyState.classList.toggle('collection-grid__empty-state--hidden', !shouldShowEmptyState);
    }

    updateButtonState() {
      if (!this.loadMoreButton) return;
      
      this.loadMoreButton.disabled = this.isLoading;
      if (this.content) this.content.style.display = this.isLoading ? 'none' : 'inline-flex';
      if (this.spinner) this.spinner.style.display = this.isLoading ? 'block' : 'none';
    }
  }

  if (!customElements.get('collection-grid-display')) {
    customElements.define('collection-grid-display', CollectionGridDisplay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-installation-type-filters"] && !Shopify.designMode) return;
  try {
    class CollectionInstallationTypeFilters extends HTMLElement {
    constructor() {
      super();
      this.categories = this.querySelectorAll('.collection-filter__category[data-filter-type]');
      this.defaultCategory = this.querySelector('.collection-filter__category[data-filter-type][data-filter-value=""]');
      this.categories.forEach((category) => {
        category.addEventListener('click', (event) => this.onCategoryClick(event));
      });

      document.addEventListener('collection:data-ready', (event) => {
        this.syncActiveCategory(event?.detail?.activeFilters);
      });

      document.addEventListener('collection:filter-changed', (event) => {
        this.syncActiveCategory(event?.detail?.activeFilters);
      });

      document.addEventListener('collection:filters-cleared', () => this.resetToDefault());
    }

    onCategoryClick(event) {
      const category = event.currentTarget;
      if (!category) return;
      if (category.classList.contains('collection-filter__category--active')) return;

      this.categories.forEach((item) => item.classList.remove('collection-filter__category--active'));
      category.classList.add('collection-filter__category--active');

      const filterType = category.dataset.filterType;
      const filterValue = category.dataset.filterValue;
      const values = [];

      if (filterValue) {
        values.push(filterValue.toLowerCase());
      }

      this.dispatchEvent(new CustomEvent('collection:filter-interface-change', {
        detail: {
          filterType,
          filterValue,
          values
        },
        bubbles: true
      }));
    }

    resetToDefault() {
      this.categories.forEach((item) => item.classList.remove('collection-filter__category--active'));
      this.defaultCategory?.classList.add('collection-filter__category--active');
    }

    syncActiveCategory(activeFilters) {
      const filterUtils = window.CollectionFilterUtils;
      if (!filterUtils) {
        this.resetToDefault();
        return;
      }

      const criteria = filterUtils.normalizeCriteria(activeFilters?.['installation-types']);
      const activeValue = criteria[0]?.value || '';

      this.categories.forEach((item) => item.classList.remove('collection-filter__category--active'));

      if (!activeValue) {
        this.defaultCategory?.classList.add('collection-filter__category--active');
        return;
      }

      const targetCategory = Array.from(this.categories).find((item) => {
        const value = item.dataset.filterValue?.toString().toLowerCase().trim() || '';
        return value === activeValue;
      });

      if (targetCategory) {
        targetCategory.classList.add('collection-filter__category--active');
      } else {
        this.defaultCategory?.classList.add('collection-filter__category--active');
      }
    }
  }

  if (!customElements.get('collection-installation-type-filters')) {
    customElements.define('collection-installation-type-filters', CollectionInstallationTypeFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-list-display"] && !Shopify.designMode) return;
  try {
    class CollectionListDisplay extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('#CollectionList');
      this.loadMoreContainer = this.querySelector('#ListLoadMoreContainer');
      this.loadMoreButton = this.querySelector('#ListLoadMoreButton');
      this.spinner = this.querySelector('.collection-list__loading-spinner');
      this.content = this.querySelector('.collection-list__load-more-content');
      
      this.productsPerPage = 21;
      this.currentPage = 1;
      this.allProducts = [];
      this.filteredProducts = [];
      this.activeFilters = {};
      this.hasMoreOnServer = false;
      this.isLoading = false;

      this.initEventListeners();
      this.initProducts();
    }

    initProducts() {
      // Collect initial products from DOM (within groups)
      this.allProducts = Array.from(this.list.querySelectorAll('.product-tile-list'));
      this.filteredProducts = [...this.allProducts];
      this.collectionGroups = Array.from(this.list.querySelectorAll('.collection-list__group'));
      this.renderProducts();
      this.updateLoadMoreVisibility();
    }

    initEventListeners() {
      // Listen for load more button click
      this.loadMoreButton?.addEventListener('click', () => this.onLoadMoreClick());

      // Listen for data provider events
      document.addEventListener('collection:data-ready', (e) => this.onDataReady(e));
      document.addEventListener('collection:new-data', (e) => this.onNewData(e));
      document.addEventListener('collection:filter-changed', (e) => this.onFilterChanged(e));
      document.addEventListener('collection:loading', (e) => this.onLoading(e));
    }

    onDataReady(e) {
      this.hasMoreOnServer = e.detail.hasMore;
      this.activeFilters = e.detail.activeFilters || {};
      this.applyFilters();
      this.renderProducts();
      this.updateLoadMoreVisibility();
    }

    onNewData(e) {
      const { listProducts, hasMore, advancePage } = e.detail;
      this.hasMoreOnServer = hasMore;

      if (listProducts && listProducts.length > 0) {
        listProducts.forEach(groupHtml => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = groupHtml.trim();
          const newGroup = tempDiv.firstElementChild;

          if (!newGroup) return;

          const handle = newGroup.dataset.collectionHandle;
          const existingGroup = this.list.querySelector(`.collection-list__group[data-collection-handle="${handle}"]`);

          if (existingGroup) {
            // Merge products into existing collection group
            const existingProducts = existingGroup.querySelector('.collection-list__group-products');
            const newProducts = newGroup.querySelector('.collection-list__group-products');
            if (existingProducts && newProducts) {
              Array.from(newProducts.children).forEach(product => {
                existingProducts.appendChild(product);
              });
            }
          } else {
            // Append as a new collection group
            this.list.appendChild(newGroup);
          }
        });

        // Update product references
        this.allProducts = Array.from(this.list.querySelectorAll('.product-tile-list'));
        this.collectionGroups = Array.from(this.list.querySelectorAll('.collection-list__group'));
        
        // Re-apply active filters after adding products.
        this.applyFilters();
      }

      if (advancePage !== false) {
        this.currentPage++;
      }

      this.renderProducts();
      this.updateLoadMoreVisibility();
    }

    onFilterChanged(e) {
      const { activeFilters, hasMore } = e.detail;
      this.activeFilters = activeFilters || {};
      this.hasMoreOnServer = hasMore;
      this.currentPage = 1;
      
      this.applyFilters();
      this.renderProducts();
      this.updateLoadMoreVisibility();
    }

    onLoading(e) {
      this.isLoading = e.detail.isLoading;
      this.updateButtonState();
    }

    hasActiveFilters() {
      return Object.keys(this.activeFilters).length > 0;
    }

    getProductFilterValues(product, filterType) {
      const dataAttributeKey = filterType.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
      const dataValue = product.dataset[dataAttributeKey] || '';

      return dataValue
        .toLowerCase()
        .split(',')
        .map((value) => value.trim())
        .filter((value) => value !== '');
    }

    matchesAllFilters(product) {
      const filterUtils = window.CollectionFilterUtils;
      const filterTypes = Object.keys(this.activeFilters);
      if (!filterTypes.length) return true;

      return filterTypes.every((filterType) => {
        const filterCriteria = filterUtils.normalizeCriteria(this.activeFilters[filterType]);
        if (!filterCriteria.length) return true;

        const productValues = this.getProductFilterValues(product, filterType);
        if (!productValues.length) return false;

        return filterCriteria.some((criterion) => filterUtils.matchesFilterCriterion(productValues, filterType, criterion));
      });
    }

    applyFilters() {
      if (!this.hasActiveFilters()) {
        this.filteredProducts = [...this.allProducts];
        this.dispatchResultsCount();
        return;
      }

      this.filteredProducts = this.allProducts.filter((product) => this.matchesAllFilters(product));
      this.dispatchResultsCount();
    }

    dispatchResultsCount() {
      this.dispatchEvent(new CustomEvent('collection:results-count-updated', {
        detail: {
          count: this.filteredProducts.length,
          hasActiveFilters: this.hasActiveFilters()
        },
        bubbles: true
      }));
    }

    onLoadMoreClick() {
      if (this.isLoading) return;

      const totalVisible = this.currentPage * this.productsPerPage;
      const hasMoreLocal = totalVisible < this.filteredProducts.length;

      if (hasMoreLocal) {
        // Show more from local pool
        this.currentPage++;
        this.renderProducts();
        this.updateLoadMoreVisibility();
      } else if (this.hasMoreOnServer) {
        // Request more from server
        document.dispatchEvent(new CustomEvent('collection:request-more', { bubbles: true }));
      }
    }

    renderProducts() {
      const totalVisible = this.currentPage * this.productsPerPage;

      // Hide all products first
      this.allProducts.forEach(p => {
        p.style.display = 'none';
      });

      // Show only matching products up to the current page
      this.filteredProducts.slice(0, totalVisible).forEach(product => {
        product.style.display = '';
      });

      // Update collection group visibility based on whether they have visible products
      this.collectionGroups.forEach(group => {
        const visibleProducts = group.querySelectorAll('.product-tile-list:not([style*="display: none"])');
        group.style.display = visibleProducts.length > 0 ? '' : 'none';
      });
    }

    updateLoadMoreVisibility() {
      if (!this.loadMoreContainer) return;

      const totalVisible = this.currentPage * this.productsPerPage;
      const hasMoreLocal = totalVisible < this.filteredProducts.length;
      const shouldShow = hasMoreLocal || this.hasMoreOnServer;

      this.loadMoreContainer.classList.toggle('collection-list__load-more-container--hidden', !shouldShow);
    }

    updateButtonState() {
      if (!this.loadMoreButton) return;
      
      this.loadMoreButton.disabled = this.isLoading;
      if (this.content) this.content.style.display = this.isLoading ? 'none' : 'inline-flex';
      if (this.spinner) this.spinner.style.display = this.isLoading ? 'block' : 'none';
    }
  }

  if (!customElements.get('collection-list-display')) {
    customElements.define('collection-list-display', CollectionListDisplay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-submenu"] && !Shopify.designMode) return;
  try {
    class CollectionSubmenu extends HTMLElement {
    constructor() {
      super();
      this.activeDot = this.querySelector('#CollectionFilterActiveDot');
      this.clearFiltersButton = this.querySelector('#CollectionClearFiltersButton');
      this.resultsLabel = this.querySelector('#CollectionSubmenuResultsLabel');
      this.resultsTemplate = this.resultsLabel?.dataset?.template || 'Displaying __COUNT__ results';
      this.initEventListeners();
    }

    initEventListeners() {
      document.addEventListener('collection:data-ready', (event) => {
        this.updateFilterVisualState(event?.detail?.activeFilters);
      });

      document.addEventListener('collection:filter-changed', (event) => {
        this.updateFilterVisualState(event?.detail?.activeFilters);
      });

      document.addEventListener('collection:results-count-updated', (event) => {
        this.updateResultsLabel(event?.detail?.count, event?.detail?.hasActiveFilters);
      });

      this.clearFiltersButton?.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('collection:clear-filters-request', {
          bubbles: true
        }));
      });
    }

    hasActiveFilters(activeFilters) {
      if (!activeFilters || typeof activeFilters !== 'object') return false;

      return Object.keys(activeFilters).some((filterType) => {
        const criteria = activeFilters[filterType];
        return Array.isArray(criteria) && criteria.length > 0;
      });
    }

    updateFilterVisualState(activeFilters) {
      const hasFilters = this.hasActiveFilters(activeFilters);
      this.activeDot?.classList.toggle('collection-filter-button__active-dot--hidden', !hasFilters);
      this.clearFiltersButton?.classList.toggle('collection-clear-filters-button--hidden', !hasFilters);

      if (!hasFilters) {
        this.resultsLabel?.classList.add('collection-submenu__results-label--hidden');
      }
    }

    updateResultsLabel(count, hasActiveFilters) {
      if (!this.resultsLabel) return;

      if (!hasActiveFilters) {
        this.resultsLabel.classList.add('collection-submenu__results-label--hidden');
        return;
      }

      const parsedCount = Number.parseInt(count, 10);
      const safeCount = Number.isNaN(parsedCount) ? 0 : parsedCount;
      this.resultsLabel.textContent = this.resultsTemplate.replace('__COUNT__', safeCount);
      this.resultsLabel.classList.remove('collection-submenu__results-label--hidden');
    }
  }

  if (!customElements.get('collection-submenu')) {
    customElements.define('collection-submenu', CollectionSubmenu);
  }

  class CollectionModeSwitcher extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.collection-mode-switcher__button');
      this.activeMode = 'grid';

      this.buttons.forEach(button => {
        button.addEventListener('click', (e) => this.onModeChange(e));
      });
    }

    onModeChange(e) {
      const button = e.currentTarget;
      const mode = button.dataset.mode;

      if (mode === this.activeMode) return;

      this.buttons.forEach(btn => btn.classList.remove('collection-mode-switcher__button--active'));
      button.classList.add('collection-mode-switcher__button--active');

      this.activeMode = mode;

      this.dispatchEvent(new CustomEvent('mode-change', {
        detail: { mode },
        bubbles: true
      }));
    }
  }

  if (!customElements.get('collection-mode-switcher')) {
    customElements.define('collection-mode-switcher', CollectionModeSwitcher);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["find-retailer-cta"] && !Shopify.designMode) return;
  try {
    function initFindRetailerCtas() {
    const canadianPostalCodePattern = /^[A-Z]\d[A-Z]\d[A-Z]\d$/;
    const usZipCodePattern = /^\d{5}(?:-\d{4})?$/;

    const normalizePostalCodeOrZip = (value) => {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        return null;
      }

      const compactCanadianPostalCode = trimmedValue.replace(/\s+/g, '').toUpperCase();
      if (canadianPostalCodePattern.test(compactCanadianPostalCode)) {
        return `${compactCanadianPostalCode.slice(0, 3)} ${compactCanadianPostalCode.slice(3)}`;
      }

      const compactZipCode = trimmedValue.replace(/\s+/g, '');
      if (usZipCodePattern.test(compactZipCode)) {
        return compactZipCode;
      }

      return null;
    };

    document.querySelectorAll('.find-retailer-cta__form').forEach((form) => {
      const input = form.querySelector('[data-postal-code-input]');
      const error = form.querySelector('[data-postal-code-error]');

      if (!input || !error) {
        return;
      }

      const showError = () => {
        input.setAttribute('aria-invalid', 'true');
        error.textContent = form.dataset.validationMessage || '';
        error.hidden = false;
      };

      const clearError = () => {
        input.removeAttribute('aria-invalid');
        error.textContent = '';
        error.hidden = true;
      };

      input.addEventListener('input', () => {
        if (input.getAttribute('aria-invalid') === 'true') {
          clearError();
        }
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const normalizedPostalCode = normalizePostalCodeOrZip(input.value);
        if (!normalizedPostalCode) {
          showError();
          return;
        }

        clearError();
        input.value = normalizedPostalCode;

        const targetUrl = new URL(form.dataset.findRetailerUrl || form.action, window.location.origin);
        targetUrl.searchParams.set('postalCode', normalizedPostalCode);

        window.location.href = `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFindRetailerCtas);
  } else {
    initFindRetailerCtas();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["home-benefits"] && !Shopify.designMode) return;
  try {
    class HomeBenefitsBlock extends HTMLElement {
    connectedCallback() {
      this.panels = [...this.querySelectorAll('[data-benefit-panel]')];
      this.intervalMs = Number.parseInt(this.dataset.rotationInterval, 10) || 5000;
      this.activeIndex = this.panels.findIndex((panel) => panel.classList.contains('is-active'));
      this.activeIndex = this.activeIndex >= 0 ? this.activeIndex : 0;
      this.isPaused = false;

      this.onPanelEnter = this.onPanelEnter.bind(this);
      this.onPanelLeave = this.onPanelLeave.bind(this);
      this.onPanelFocus = this.onPanelFocus.bind(this);
      this.onPanelBlur = this.onPanelBlur.bind(this);
      this.onPanelClick = this.onPanelClick.bind(this);

      this.panels.forEach((panel) => {
        panel.addEventListener('mouseenter', this.onPanelEnter);
        panel.addEventListener('mouseleave', this.onPanelLeave);
        panel.addEventListener('focusin', this.onPanelFocus);
        panel.addEventListener('focusout', this.onPanelBlur);
        panel.addEventListener('click', this.onPanelClick);
      });

      this.activate(this.activeIndex);
      this.startRotation();
    }

    disconnectedCallback() {
      this.stopRotation();

      this.panels?.forEach((panel) => {
        panel.removeEventListener('mouseenter', this.onPanelEnter);
        panel.removeEventListener('mouseleave', this.onPanelLeave);
        panel.removeEventListener('focusin', this.onPanelFocus);
        panel.removeEventListener('focusout', this.onPanelBlur);
        panel.removeEventListener('click', this.onPanelClick);
      });
    }

    activate(index) {
      this.activeIndex = index;

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    }

    startRotation() {
      this.stopRotation();
      this.rotationTimer = window.setInterval(() => {
        if (this.isPaused || this.panels.length === 0) return;

        this.activate((this.activeIndex + 1) % this.panels.length);
      }, this.intervalMs);
    }

    stopRotation() {
      if (!this.rotationTimer) return;

      window.clearInterval(this.rotationTimer);
      this.rotationTimer = null;
    }

    onPanelEnter(event) {
      this.isPaused = true;
      this.activate(this.panels.indexOf(event.currentTarget));
    }

    onPanelLeave() {
      this.isPaused = false;
    }

    onPanelFocus(event) {
      this.isPaused = true;
      this.activate(this.panels.indexOf(event.currentTarget));
    }

    onPanelBlur() {
      window.requestAnimationFrame(() => {
        this.isPaused = this.matches(':focus-within');
      });
    }

    onPanelClick(event) {
      this.activate(this.panels.indexOf(event.currentTarget));
    }
  }

  if (!customElements.get('home-benefits-block')) {
    customElements.define('home-benefits-block', HomeBenefitsBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-carousel"] && !Shopify.designMode) return;
  try {
    class ProductCarouselBlock extends HTMLElement {
    constructor() {
      super();

      this.onPreviousClick = this.onPreviousClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onCarouselScroll = this.onCarouselScroll.bind(this);
      this.onWindowResize = this.onWindowResize.bind(this);
      this.onWheel = this.onWheel.bind(this);
    }

    connectedCallback() {
      this.carousel = this.querySelector('[data-product-carousel]');
      this.carouselInner = this.querySelector('[data-product-carousel-track]');
      this.previousButton = this.querySelector('[data-product-carousel-prev]');
      this.nextButton = this.querySelector('[data-product-carousel-next]');

      this.previousButton?.addEventListener('click', this.onPreviousClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.carouselInner?.addEventListener('scroll', this.onCarouselScroll, { passive: true });
      this.carouselInner?.addEventListener('wheel', this.onWheel, { passive: false });
      window.addEventListener('resize', this.onWindowResize);

      this.updateCarouselControls();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.onPreviousClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.carouselInner?.removeEventListener('scroll', this.onCarouselScroll);
      this.carouselInner?.removeEventListener('wheel', this.onWheel);
      window.removeEventListener('resize', this.onWindowResize);
    }

    updateCarouselControlPosition() {
      if (!this.carouselInner || !this.carousel) return;

      const firstTile = this.carouselInner.querySelector('.product-tile');
      const visualTarget = firstTile?.querySelector('.product-tile__image-wrapper') || firstTile;
      if (!visualTarget) return;

      const carouselRect = this.carousel.getBoundingClientRect();
      const visualRect = visualTarget.getBoundingClientRect();
      const visualCenter = visualRect.top + (visualRect.height / 2) - carouselRect.top;
      this.carousel.style.setProperty('--product-carousel-control-top', `${visualCenter}px`);
    }

    getScrollStep() {
      const firstTile = this.carouselInner?.querySelector('.product-tile');
      if (!firstTile) return this.carouselInner?.clientWidth || 0;

      const styles = window.getComputedStyle(this.carouselInner);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return firstTile.getBoundingClientRect().width + gap;
    }

    scrollByStep(direction) {
      if (!this.carouselInner) return;

      this.carouselInner.scrollBy({
        left: this.getScrollStep() * direction,
        behavior: 'smooth'
      });
    }

    onPreviousClick() {
      this.scrollByStep(-1);
    }

    onNextClick() {
      this.scrollByStep(1);
    }

    onCarouselScroll() {
      this.updateCarouselControls();
    }

    onWindowResize() {
      window.requestAnimationFrame(() => this.updateCarouselControls());
    }

    updateCarouselControls() {
      if (!this.carouselInner || !this.carousel) return;

      this.updateCarouselControlPosition();

      const maxScrollLeft = this.carouselInner.scrollWidth - this.carouselInner.clientWidth;
      const isScrollable = maxScrollLeft > 1;
      const isAtStart = this.carouselInner.scrollLeft <= 1;
      const isAtEnd = this.carouselInner.scrollLeft >= maxScrollLeft - 1;

      this.carousel.classList.toggle('is-scrollable', isScrollable);

      if (this.previousButton) {
        this.previousButton.disabled = !isScrollable || isAtStart;
        this.previousButton.setAttribute('aria-hidden', (!isScrollable).toString());
      }

      if (this.nextButton) {
        this.nextButton.disabled = !isScrollable || isAtEnd;
        this.nextButton.setAttribute('aria-hidden', (!isScrollable).toString());
      }
    }

    onWheel(event) {
      if (!this.carouselInner) return;
      if (Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;

      const maxScrollLeft = this.carouselInner.scrollWidth - this.carouselInner.clientWidth;
      const direction = Math.sign(event.deltaY);
      const canScrollLeft = this.carouselInner.scrollLeft > 1;
      const canScrollRight = this.carouselInner.scrollLeft < maxScrollLeft - 1;

      if ((direction < 0 && !canScrollLeft) || (direction > 0 && !canScrollRight)) return;

      event.preventDefault();
      this.carouselInner.scrollLeft += event.deltaY;
    }
  }

  if (!customElements.get('product-carousel-block')) {
    customElements.define('product-carousel-block', ProductCarouselBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
